<template>
    <div class="container">
        <div class="handle-box">
            <div class="handle-left">
                <el-select v-model="query.news_type" filterable collapse-tags clearable placeholder="婚宴信息" class="handle-select mr10 w7rem" style="width: 11.5rem">
                    <el-option v-for="(row, index) in pickerList.newsTypeList" :key="index" :label="row.title" :value="row.id"></el-option>
                </el-select>
                <el-select v-model="query.store_id" filterable multiple collapse-tags clearable placeholder="选择门店" class="handle-select mr10 w7rem" style="width: 11.5rem">
                    <el-option v-for="(row, index) in pickerList.storeList" :key="index" :label="row.title" :value="row.id"></el-option>
                </el-select>
                <el-select v-model="query.user_id" filterable multiple collapse-tags clearable placeholder="选择跟单人" class="handle-select mr10 w7rem" style="width: 11.5rem">
                    <el-option v-for="(row, index) in pickerList.userList" :key="index" :label="row.title" :value="row.id"></el-option>
                </el-select>
                <el-select v-model="query.sales_id" filterable multiple collapse-tags clearable placeholder="订单销售" class="handle-select mr10 w7rem" style="width: 11.5rem">
                    <el-option v-for="(row, index) in pickerList.userList" :key="index" :label="row.title" :value="row.id"></el-option>
                </el-select>
                <el-input v-model="query.mobile" placeholder="请输入手机号" style="width: 200px"></el-input>
                <el-date-picker class="daterange mr10" v-model="query.range" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>

                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button type="primary" icon="el-icon-download" @click="exportExcel">导出</el-button>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">刷新</el-button>
            </div>
        </div>
        <el-table id="out-table" :data="tableData" :height="height" border class="table" ref="multipleTable" header-cell-class-name="table-header" :default-sort="{ prop: 'sign_date' }" v-loading="loading">
            <el-table-column type="index" width="60" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="操作" width="160" v-if="user.id == '675'">
                <template slot-scope="scope">
                    <template>
                        <el-button type="primary" size="mini" icon="el-icon-edit" @click="$refs.editBox.handleShow(scope.row)"></el-button>
                        <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteFn(scope.row.id)"></el-button>
                    </template>
                </template>
            </el-table-column>
            <el-table-column prop="item_check_status_text" label="审核状态" width="120"></el-table-column>
            <el-table-column prop="news_type_text" label="订单类型" width="150" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="是否计算当月业绩" width="160">
                <template slot-scope="scope">
                    <div>{{ scope.row.is_achievement == 1 ? '计算业绩' : '不计算业绩' }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="contract_no" label="合同编号" width="150" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="realname" label="客户姓名" width="150" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="mobile" label="客户手机号" width="150" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="store_text" label="成单门店" width="150" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="table_amount" label="桌数" width="150" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="table_price" label="餐标" width="150" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="totals" label="总价" width="150" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="sales_text" label="签单销售" width="150" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="user_text" label="跟单人" width="150" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="event_date" label="婚期" width="150" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="department_text" label="成单部门" width="150" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="create_time" label="录入时间" width="150" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="check_date" label="审核通过时间" width="150" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
        <editBox ref="editBox" @getInfo="getInfo"></editBox>
        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[15, 20, 30, 50]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
        </div>
    </div>
</template>

<script>
import '../../../profit/common.css';
import fileSaver from 'file-saver';
import xlsx from 'xlsx';
import editBox from './edit.vue';
export default {
    components: {
        editBox
        // editProfit
    },
    name: 'basetable',
    data() {
        return {
            loading: false,

            height: 660,
            tableData: [],
            pagination: {
                page: 1,
                limit: 15,
                total: 0
            },
            query: {
                member_id: '',
                news_type: '',
                contract_no: '',
                realname: '',
                mobile: '',
                store_id: '',
                event_date: '',
                table_amount: '',
                table_price: '',
                totals: '',
                user_id: '',
                sales_id: '',
                remark: '',
                images: []
            },
            pickerList: {},
            user: {},
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    created() {
        this.height = window.innerHeight * 0.75;
        this.user = JSON.parse(localStorage.getItem('user'));

        this.getData();
        this.getPicker();
    },
    methods: {
        getData() {
            let that = this;
            let url = '/api/order.customer/index';
            let query = that.query;
            query.pagination = this.pagination;
            that.loading = true;
            this.$post(url, query).then(function (response) {
                let result = response.data;
                that.tableData = result.list;
                that.pagination = result.pagination;
                that.loading = false;
            });
        },
        //编辑成功重新获取数据
        getInfo() {
            this.getData();
        },
        // 触发搜索按钮
        handleSearch() {
            this.getData();
        },
        //获取订单picker
        getPicker() {
            let that = this;
            let url = '/api/order.customer/picker';
            let query = {};
            this.$post(url, query).then((res) => {
                if (res.code == 200) {
                    that.pickerList = res.data;
                }
            });
        },
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getData();
        },
        exportExcel() {
            /* 从表生成工作簿对象 */
            var wb = xlsx.utils.table_to_book(document.querySelector('#out-table'));
            /* 获取二进制字符串作为输出 */
            var wbout = xlsx.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                fileSaver.saveAs(
                    //Blob 对象表示一个不可变、原始数据的类文件对象。
                    //Blob 表示的不一定是JavaScript原生格式的数据。
                    //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                    //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                    new Blob([wbout], {
                        type: 'application/octet-stream'
                    }),
                    //设置导出文件名称
                    'sheetjs.xlsx'
                );
            } catch (e) { }
            return wbout;
        },
        //删除操作
        deleteFn(id) {
            let url = '/api/order.customer/delete';
            let query = { id: id };
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$post(url, query).then((res) => {
                        if (res.code == 200) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.getData();
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        }
    }
};
</script>

